import {
  ValueError,
  ValueErrorIterator
} from "@sinclair/typebox/build/cjs/errors";
import { MappedError, mapValueErrorIterator } from "./mapValueErrorIterator";

export class DataLayerError extends Error {
  validationErrors: MappedError[];

  constructor({
    message,
    errors = []
  }: {
    message: string;
    errors?: ValueError[] | ValueErrorIterator;
  }) {
    super(message);
    this.message = message;
    this.validationErrors = mapValueErrorIterator(errors);
  }
}
